// abortcontroller-polyfill обеспечивает поддержку функциональности AbortController и метода fetch в старых браузерах (Chrome 66 и ниже)
import "abortcontroller-polyfill/dist/polyfill-patch-fetch";
// #region Chrome 49
import "core-js/features/object/values";
import "core-js/stable";

if (window.NodeList && !NodeList.prototype.forEach) {
  // eslint-disable-next-line func-names
  NodeList.prototype.forEach = function (callback, thisArg) {
    // eslint-disable-next-line no-var
    var patchedThisArg = thisArg || window;
    // eslint-disable-next-line no-var, vars-on-top
    for (var i = 0; i < this.length; i++) {
      callback.call(patchedThisArg, this[i]!, i, this);
    }
  };
}
// #endregion
